import { RouteRecordRaw } from "vue-router"

export const designSystemRoutes: RouteRecordRaw[] = [
	{
		path: "/design-system",
		name: "components",
		component: () => import("@/pages/design-system/Components.vue"),
		meta: {
			title: "",
            layout: "MainLayout",
			authRequired: true
		}
	}
]
